export const EditTaskIcon = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Group">
      <path
        id="Vector"
        d="M12.9 7.35808L17.142 11.6011L7.242 21.5001H3V17.2571L12.9 7.35708V7.35808ZM14.314 5.94408L16.435 3.82208C16.6225 3.63461 16.8768 3.5293 17.142 3.5293C17.4072 3.5293 17.6615 3.63461 17.849 3.82208L20.678 6.65108C20.8655 6.83861 20.9708 7.09292 20.9708 7.35808C20.9708 7.62325 20.8655 7.87756 20.678 8.06508L18.556 10.1861L14.314 5.94408Z"
        fill="#2D5BFF"
      />
    </g>
  </svg>
);
